import {
  SR_API_ACTION_APPLY_TOUR_STATE_CHANGE,
} from 'api/actionTypes';

export default async function actionApplyTourStateChange({ state, apiClient }, payload) {
  const {
    entityId,
    entityTransitionUpdates,
    toState,
  } = payload;

  await apiClient.postWithState({
    action: SR_API_ACTION_APPLY_TOUR_STATE_CHANGE,
    queryId: String(entityId),
    state: state,
    payload: {
      entityId,
      entityTransitionUpdates,
      toState,
    },
  });
}
